import type { FC, ReactNode } from 'react';

import { InfoCardWrapStyled } from './InfoCard.styled';

export type InfoCardPropsT = {
  children: ReactNode;
  className?: string;
  /** When true, reduces vertical padding (e.g. for message bubble card). Default false. */
  compact?: boolean;
  /** When false, card width is fit-content (e.g. for dealer report cards in a row). Default true. */
  fullWidth?: boolean;
};

/**
 * Card component matching WarrQueue Repair Order Info card style on the work item screen.
 * Use to wrap BannerMessages, each dealer report card, or similar content.
 */
const InfoCard: FC<InfoCardPropsT> = ({
  children,
  className,
  compact = false,
  fullWidth = true,
}) => {
  return (
    <InfoCardWrapStyled className={className} compact={compact} fullWidth={fullWidth} tabIndex={0}>
      {children}
    </InfoCardWrapStyled>
  );
};

export default InfoCard;
